export function inputCls(error) {
  return `w-full bg-[#2c2c2c] border ${
    error ? "border-[#e93529]" : "border-[#4a4a4a] focus:border-[#e93529]"
  } focus:outline-none rounded-lg px-3 py-2.5 text-sm text-white placeholder-[#6a6a6a] transition-colors`;
}

export function Field({ label, error, required, children }) {
  return (
    <div>
      <label className="block text-xs font-semibold text-[#8a8a8a] uppercase tracking-wider mb-1.5">
        {label}
        {required && <span className="text-[#e93529] ml-0.5">*</span>}
      </label>
      {children}
      {error && <p className="text-[#f04f44] text-xs mt-1">{error}</p>}
    </div>
  );
}
